import { render, staticRenderFns } from "./FrameworkCreation.vue?vue&type=template&id=64442d8c&scoped=true"
import script from "./FrameworkCreation.vue?vue&type=script&lang=js"
export * from "./FrameworkCreation.vue?vue&type=script&lang=js"
import style0 from "./FrameworkCreation.vue?vue&type=style&index=0&id=64442d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64442d8c",
  null
  
)

export default component.exports